module.exports = __webpack_public_path__ + "img/sfgy.884f78cb.png";